import request from '@/http/request'
// 可用代收通道 下拉框
export const getPayInIntegrationChannel = (appId) => {
  return request.request({
    url: `/api/integration/test/pay-in/passage/${appId}`,
    method: 'GET'
  })
}

// 可用代付通道
export const getPayOututIntegrationChannel = (appId) => {
  return request.request({
    url: `/api/integration/test/pay-out/passage/${appId}`,
    method: 'GET'
  })
}

// 创建代付订单
// /api/integration/test/pay-out/create
// 获取对接信息
// ntegrationTestPayoutOrderCreateRQ
// appId
// string
// 应用ID
// 可选
// wayCode
// string
// 支付编码
// 可选
// amount
// number
// 支付金额
// 可选
// notifyUrl
// string
// 回调地址
// 可选
// bankCode
// string
// 银行编码
// 可选
// bankAccountNumber
// string
// 银行账户号
// 可选
// bankAccountUsername
// string
// 银行账户名
export const createPayOutOrder = (data) => {
  return request.request({
    url: '/api/integration/test/pay-out/create',
    method: 'POST',
    data
  })
}
// /api/integration/test/pay-in/create
export const createPayInOrder = (data) => {
  return request.request({
    url: '/api/integration/test/pay-in/create',
    method: 'POST',
    data
  })
}

export const getIntegrationInfo = () => {
  return request.request({
    url: '/api/integration/info',
    method: 'GET'
  })
}

// 获取商户应用列表（修正为API_URL_MCH_APP）
export const getMchAppList = () => {
  return request.request({
    url: '/api/mchApps',
    method: 'GET',
    params: { pageSize: -1 }
  })
}

// 对接文档 app密钥获取
export const getAppKey = (appId) => {
  return request.request({
    url: `/api/integration/doc/app/${appId}/secret`,
    method: 'GET'
  })
}

// /api/integration/sdk
// 对接sdk
export const getIntegrationSdk = () => {
  return request.request({
    url: `/api/integration/sdk`,
    method: 'GET'
  })
}

// 获取demo下载
export const getIntegrationDemo = () => {
  return request.request({
    url: `/api/integration/demo`,
    method: 'GET'
  })
}
